module.exports = __webpack_public_path__ + "static/media/Expense-Management.938699ff.png";